import { StateCreator } from 'zustand'
import { SharedSlice } from 'src/components/slice'
import { RosterTemplate } from '$models'
import { exceptionMessageHandler } from '$utils'
import { rosterService } from '$services'

interface RostersState {
  rosterTemplates: RosterTemplate[]
}

export interface RostersSlice extends RostersState {
  /**
   * Resets Rosters Slice state
   */
  resetRostersSlice: () => void

  /**
   * Get Roster Templates list
   * @param includeDeleted
   */
  getRosterTemplates: (includeDeleted?: boolean) => Promise<void>
}

const initialState: RostersState = {
  rosterTemplates: [],
}

const createRostersSlice: StateCreator<
  RostersSlice & SharedSlice,
  [],
  [],
  RostersSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  resetRostersSlice: () => set(initialState),

  getRosterTemplates: async (
    includeDeleted: boolean = false
  ): Promise<void> => {
    return rosterService
      .getTemplates(includeDeleted)
      .then((result: RosterTemplate[]) => {
        return set(() => ({
          rosterTemplates: result,
        }))
      })
      .catch((error) => {
        set(() => ({
          rosterTemplates: [],
        }))
        exceptionMessageHandler(error, 'Failed to retrieve roster templates')
      })
      .finally(() => {
        set(() => ({ isLoading: false }))
      })
  },
})

export default createRostersSlice
